/**
 * Barcode Handler Priority Levels
 *
 * Defines priority values for barcode scan handlers in the global scanner system.
 * Higher priority handlers receive scan events first. When multiple handlers are
 * registered, only the highest priority handler receives the scan.
 */
export const BARCODE_HANDLER_PRIORITIES = {
  /**
   * SelectActivity modal - Highest priority
   * Active when user is selecting activity type after work order selection
   */
  SELECT_ACTIVITY_MODAL: 100,

  /**
   * SelectWorkOrderOp modal - High priority
   * Active when user is selecting work order operation
   */
  SELECT_WORK_ORDER_MODAL: 90,

  /**
   * SelectActivityType page - Medium priority
   * Active when on dedicated activity selection page
   */
  SELECT_ACTIVITY_PAGE: 50,

  /**
   * Pick Material step in the job-start flow - sits between work order and
   * activity selection, so it must outrank the work-order modal.
   */
  PICK_MATERIAL_STEP: 95,

  /**
   * Machine home page - Lowest priority (fallback)
   * Always active as base handler when no higher priority handlers are registered
   */
  MACHINE_HOME: 0,
};
